export const HEADER_LIST = [
    {
        url: '/',
        name: 'How We Help' ,
        subMenu: [
           "dummy",
           "dummy",
           "dummy",
        ]
    },
    {
        url: '/',
        name: 'Who We Help' ,
        subMenu: [
           "dummy",
           "dummy",
           "dummy",
        ]
    },
    {
        url: '/',
        name: 'Why Venveo' ,
        subMenu: [
           "dummy",
           "dummy",
           "dummy",
        ]
    },
    {
        url: '/',
        name: 'Resources' ,
        subMenu: [
           "dummy",
           "dummy",
           "dummy",
        ]
    },


]